import React from 'react';
import { useParams } from 'react-router-dom';
import { useIsMobile } from '../common/layout_hooks';
import RecipeSingleCollectionMobileView from './recipe_single_collection_mobile_view';
import RecipeSingleCollectionDesktopView from './recipe_single_collection_desktop_view';
import { useGetSmorgBoardQuery } from '../../app/smorgAppSyncGraphQLApi';

const RecipeSingleCollectionView = () => {
  const isMobile = useIsMobile();

  const { boardID } = useParams();

  const { data: ownRecipesBoard, isLoading: isOwnRecipesBoardLoading } =
    useGetSmorgBoardQuery(boardID, { skip: !boardID });

  const isOwnRecipesBoard = !isOwnRecipesBoardLoading && !!ownRecipesBoard;

  if (!isMobile && isOwnRecipesBoard) {
    return <RecipeSingleCollectionDesktopView />;
  }

  return <RecipeSingleCollectionMobileView />;
};

export default RecipeSingleCollectionView;
